import { render, staticRenderFns } from "./EventsContestantsFilterDivisions.vue?vue&type=template&id=3e1bca97&"
import script from "./EventsContestantsFilterDivisions.vue?vue&type=script&lang=ts&"
export * from "./EventsContestantsFilterDivisions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports